const styleOverrides = {
  positionStart: {
    marginRight: 0,
  },
  positionEnd: {
    marginLeft: 0,
  },
};

export default styleOverrides;
